module.exports = __webpack_public_path__ + "img/gravier_roule_saint_renan.06681d71.jpg";